// Shared constants for time series charts

/** Oahu respiratory-target blues (default for small series counts). */
export const DEFAULT_SERIES_COLORS = [
  "#a9deff",
  "#37b2ff",
  "#2873ae",
  "#e0f3ff",
]

/** Oahu wastewater chart palettes by target group. */
export const WASTEWATER_TARGET_GROUP_COLORS = {
  "Respiratory Diseases": ["#a9deff", "#37b2ff", "#2873ae", "#e0f3ff"],
  "Gastrointestinal Diseases": ["#ffd8bd", "#ffa96c", "#e15d22"],
  "Other Diseases": ["#b366ff", "#d999e5", "#cd37ff", "#75008b"],
} as const

/** Full Oahu wastewater chart palette (all target groups). */
export const MULTI_SITE_SERIES_COLORS = [
  ...WASTEWATER_TARGET_GROUP_COLORS["Respiratory Diseases"],
  ...WASTEWATER_TARGET_GROUP_COLORS["Gastrointestinal Diseases"],
  ...WASTEWATER_TARGET_GROUP_COLORS["Other Diseases"],
]

// Time series data structure
export interface DatasetEntry {
  date: Date
  [key: string]: Date | number | null
}
